module.exports = __webpack_public_path__ + "static/media/I Quaff the Fog Juice.f6cf31e4.mp3";